// extracted by mini-css-extract-plugin
module.exports = {"reportListItemFallback":"ReportListItemFallback_reportListItemFallback__1eiG5"};